import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { clientsApi } from './clients.api';
import type { ClientsListParams } from '../types';
import { STALE_TIME } from '@/lib/query/stale-times';

export const clientKeys = {
  all: ['clients'] as const,
  lists: () => [...clientKeys.all, 'list'] as const,
  list: (filters: ClientsListParams) =>
    [...clientKeys.lists(), filters] as const,
  details: () => [...clientKeys.all, 'detail'] as const,
  detail: (id: number) => [...clientKeys.details(), id] as const,
  metrics: () => [...clientKeys.all, 'metrics'] as const
};

export const clientQueries = {
  list: (filters: ClientsListParams = {}) =>
    queryOptions({
      queryKey: clientKeys.list(filters),
      queryFn: () => clientsApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: clientKeys.detail(id),
      queryFn: () => clientsApi.getById(id),
      enabled: id > 0
    }),

  metrics: () =>
    queryOptions({
      queryKey: clientKeys.metrics(),
      queryFn: () => clientsApi.metrics(),
      staleTime: STALE_TIME.metrics
    })
};
